module.exports = __webpack_public_path__ + "img/accessory_shirt_06.cb1bd38b.svg";